import React, { useEffect, useState } from 'react'
import { FoundationsButton } from '../../GenericComponents/button'
import { useNavigate,useLocation } from 'react-router-dom'
import { getBaseUrl } from '../../Utils';
import { cleanHLUserCookies, getCurrentCookiePath, startProxyCheckThread } from '../../GlobalMethods';
import { useDispatch } from 'react-redux';
import { appWorkflowStates } from "../../Types/appWorkflowStates";
import { usePerformSignOutMutation } from '../../Redux/Admin_Tasks/AdminProcedureSlice';
import { setAppWorkflowState } from '../../Redux/store';

const PageNotAccessibleIfLoggedIn:React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [PerformSignOut, { data: SignOutData, error: SignOutError, isLoading: SignOutLoading }] = usePerformSignOutMutation()

   const handleSignOut = async () => {
        try {
            const response = await PerformSignOut().unwrap();
            if (response.Value) {
                cleanHLUserCookies()
                // Set the application workflow state to UNAUTHENTICATED
                dispatch(setAppWorkflowState(appWorkflowStates.UNAUTHENTICATED));
                navigate("/#signin");
            }
        } catch (error) {
            console.error("Sign out failed", error);
        }
    };

  const handleRedirectHome = () => {
    navigate(`#home`)
  };
  return (
    <div className="container page-body d-flex justify-content-center">
      <div className="col">
        <div className="col text-center">
          <h2>Sorry, Cannot Access This Page</h2>
        </div>
        <div className="col text-center">
          You cannot access this page because you are logged in.
        </div>
        <div className="col text-center">
          <FoundationsButton
            id="reset_button_el"
            buttonClasses="col-md-6 app-button btn-primary mt-2 log_btn"
            onClick={handleSignOut}
            classes='notacessiblepage_btn'
          >
            Sign Out
          </FoundationsButton>
          <FoundationsButton
            id="reset_button_el"
            buttonClasses="col-md-6 app-button btn-secondary mt-2 notacessiblepage_btn"
            onClick={handleRedirectHome}
            classes="notacessiblepage_btn"
          >
            Go Home
          </FoundationsButton>
        </div>
      </div>
    </div>
  );
};

export default PageNotAccessibleIfLoggedIn

